<script setup lang="ts">
import type { DSStory } from '~/types'

const props = defineProps({
  topicId: String,
  storyId: String,
})

const storyList = ref<DSStory[]>([])
const intersectGuard = ref(null)
const {
  loadNextStories,
  hasMoreStories,
} = useStoriesSortedByUpdated(props.topicId, 9)
const isCrawler = useState<boolean>('isCrawler')

const { data: tempList = [], status } = await useAsyncData(
  `storyWall-${props.storyId}-${isCrawler.value ? 'crawler' : 'normal'}`,
  () => loadNextStories(),
)

const isLoading = computed(() => status.value === 'pending')

watch(tempList, (newList) => {
  storyList.value.push(...newList)
}, { immediate: true })

let observer: IntersectionObserver | null = null

function initObserver() {
  if (observer)
    observer.disconnect()

  observer = new IntersectionObserver(async (entries) => {
    const entry = entries[0]
    if (entry.isIntersecting && !isLoading.value) {
      if (hasMoreStories.value) {
        tempList.value = await loadNextStories(storyList.value)
      } else {
        observer?.disconnect()
      }
    }
  })

  if (intersectGuard.value)
    observer.observe(intersectGuard.value)
}

onMounted(() => {
  initObserver()
})

const relatedStoryList = computed(() => {
  return storyList.value.filter(story => story.id !== props.storyId)
})
</script>

<template>
  <template v-if="relatedStoryList?.length">
    <p class="pb-4 font-semibold text-neutral-900 pt-8 article">
      探索更多故事
    </p>
    <div class="grid grid-cols-2 gap-3 pb-24">
      <common-story-card
        v-for="story in relatedStoryList"
        :key="story.id"
        :story="story"
      />
    </div>
  </template>

  <div ref="intersectGuard" class="h-[1px]" />
</template>
